import { isNullOrUndefinedOrEmpty } from "../filter-value";

const ERROR_MSG = "Please provide a value for all fields highlighted above.";

export const validateProductInputs = (data, selectedPath, setError) => {
	const baseRequired =
		isNullOrUndefinedOrEmpty(data.incomeDocType) ||
		isNullOrUndefinedOrEmpty(data.lienType) ||
		isNullOrUndefinedOrEmpty(data.lockTerm);

	if (baseRequired) {
		setError(ERROR_MSG);
		return false;
	}

	if (selectedPath === "non-aura") {
		if (
			isNullOrUndefinedOrEmpty(data.qualifyingFico) ||
			isNullOrUndefinedOrEmpty(data.housingEvent) ||
			isNullOrUndefinedOrEmpty(data.bankruptcy) ||
			isNullOrUndefinedOrEmpty(data.mortgageLates)
		) {
			setError(ERROR_MSG);
			return false;
		}
	}

	setError("");
	return true;
};

// Returns true if minimum OB API fields are populated to enable program search
export const canSearchPrograms = (data) => {
	return (
		!isNullOrUndefinedOrEmpty(data.loanAmount) &&
		!isNullOrUndefinedOrEmpty(data.ltv) &&
		!isNullOrUndefinedOrEmpty(data.propertyType) &&
		!isNullOrUndefinedOrEmpty(data.occupancy) &&
		!isNullOrUndefinedOrEmpty(data.state) &&
		!isNullOrUndefinedOrEmpty(data.qualifyingFico) &&
		!isNullOrUndefinedOrEmpty(data.incomeDocType)
	);
};

// Keeps only the flagged fields that are still invalid now, so a field highlighted
// on submit stops showing red once the user enters a value (same idea as the
// Dashboard's intersectErrors, for the { fieldName: message } error objects).
export const intersectFieldErrors = (flagged, live) => {
	const shown = {};
	if (!flagged || !live) return shown;
	Object.keys(flagged).forEach((key) => {
		if (key in live) shown[key] = flagged[key];
	});
	return shown;
};
